import React from 'react';
import { SvgIcon, type SvgIconProps } from '@mui/material';

export const MHRIcon: React.FC<SvgIconProps> = (props) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    {/* Computer monitor outer frame */}
    <rect x="1" y="1" width="22" height="17" rx="2" ry="2" stroke="currentColor" strokeWidth="1.5" fill="none" />

    {/* Computer stand base */}
    <line x1="6" y1="23" x2="18" y2="23" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />

    {/* Computer stand vertical */}
    <line x1="12" y1="19" x2="12" y2="23" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />

    {/* MHR Text */}
    <text x="12" y="12.5" textAnchor="middle" fontSize="8" fontWeight="600" fill="currentColor">
      MHR
    </text>
  </SvgIcon>
);
